import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Booking } from '../../objects/booking';
import { BookingRequest } from '../../objects/booking-request';
import { Order } from '../../objects/order';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class BookingService extends BaseService {
  createInstance = (values: Booking): Booking => values;

  createBooking(args: {
    request: BookingRequest;
  }): Observable<Booking[]> {
    const url = `${this.baseUrl}/public/bookings`;
    const payload = args.request.toJSON();

    return this.http
      .post<Booking[]>(url, payload);
  }

  /**
   * NOTE: this is a booking endpoint, and BaseService will try to return a new
   * Booking (through createInstance above). However, API returns an order.
   * Hence, we don't use super.doDelete() as in other services.
   */
  destroyBooking(payload: { item: Booking; order: Order }) {
    const url = `${this.baseUrl}/public/bookings/${payload.item.id}?order_token=${payload.order.token}`;

    return this.http.delete(url);
  }
}
